<template>
    <v-sheet class="text-center" height="200px">
        <!--<v-btn
                class="mt-6"
                text
                color="red"
                @click="sheet = !sheet"
        >close</v-btn>-->
        <div class="py-3">{{data}}</div>
    </v-sheet>
</template>

<script>


    export default {
        data: () =>({
            sheet:true
        }),
        props:["data"]
    }
</script>